import { compare } from "compare-versions";
import { _internalApiGetAppInBootstrapData, hooks } from "./Runtime.js";
export function hasInstalledApp(appId, matchVersion) {
  // First, check whether the app is in bootstrap already.
  let app = _internalApiGetAppInBootstrapData(appId);
  if (!app && hooks !== null && hooks !== void 0 && hooks.checkInstalledApps) {
    app = hooks.checkInstalledApps.getCheckedApp(appId);
  }
  if (!app || app.installStatus === "running") {
    return false;
  }
  // Todo: `currentVersion` maybe `""`
  if (!matchVersion || !app.currentVersion) {
    return true;
  }
  // Valid `matchVersion`:
  //   >=1.2.3
  //   >1.2.3
  //   =1.2.3
  //   <=1.2.3
  //   <1.2.3
  const matches = matchVersion.match(/^([><]=?|=)(.*)$/);
  try {
    if (!matches) {
      throw new TypeError(`Invalid match version: ${matchVersion}`);
    }
    return compare(app.currentVersion, matches[2], matches[1]);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return false;
}
//# sourceMappingURL=hasInstalledApp.js.map